import React from 'react';
import styled from 'styled-components';
import 'swiper/css'; // eslint-disable-line import/no-unresolved
import 'swiper/css/navigation'; // eslint-disable-line import/no-unresolved
import { Navigation, A11y } from 'swiper/modules'; // eslint-disable-line import/no-unresolved
import { Swiper, SwiperSlide } from 'swiper/react'; // eslint-disable-line import/no-unresolved
import { ascMediaInteraction } from 'helpers/src/gtag';
import Button from './button/index';
import Image from './image';

export const onSlideChange = (slides, { loop = false, gaPageType }) => (swiper) => {
  const index = swiper.activeIndex - (loop ? 1 : 0);
  const { alt, id } = slides[index] || {};
  const label = alt || id || `item ${index}`;
  ascMediaInteraction({
    page_type: gaPageType,
    media_type: 'gallery',
    creative_name: label,
  });
};

const Slideshow = ({
  // name = 'Slideshow',
  slides = [],
  imageOptions = [],
  breakpoint = 576,
  slidesPerView = 1,
  breakpoints = {}, // allow complete override
  gaPageType = 'item', // @TODO: when we run swipers on something else items, we need to change this
}) => (
  <SwiperWrapper breakpoint={breakpoint}>
    <Swiper
      modules={[Navigation, A11y]}
      slideToClickedSlide={false}
      navigation
      watchOverflow
      css="position: relative;"
      slidesPerView={1.3}
      spaceBetween={15}
      centeredSlides
      loop
      breakpoints={{
        [breakpoint]: {
          slidesPerView,
          spaceBetween: 0,
          centeredSlides: false,
        },
        ...(breakpoints || {}),
      }}
      onSlideChange={onSlideChange(slides, { loop: true, gaPageType })}
    >
      {slides.map(({
        Slide, // allow to inject a custom slide (for example: a video)
        image,
        overlayImage,
        alt,
        preferRemote,
        id,
        onClick,
        onIsActive,
        ...props
      }, index) => (Slide || image) && (
        <SwiperSlide key={id}>
          {({ isActive }) => {
            if (isActive && onIsActive) {
              setTimeout(() => onIsActive(true), 1);
            }
            if (Slide) {
              return Slide;
            }
            return (
              <div>
                <Image
                  {...props}
                  image={image}
                  preferRemote={preferRemote}
                  options={imageOptions}
                  css="max-width:100%;height:auto;display:block;"
                  alt={alt}
                  loading={index < slidesPerView ? 'eager' : 'lazy'}
                />
                {overlayImage && (
                  <Overlay
                    image={overlayImage}
                    loading="eager"
                  />
                )}
                {onClick && <OnClickButton aria-label="Open image in modal" type="button" onClick={onClick} />}
              </div>
            );
          }}
        </SwiperSlide>
      ))}
    </Swiper>
  </SwiperWrapper>
);

const SwiperWrapper = styled.div`
  margin-left: -${({ theme }) => theme.grid.containerGap};
  margin-right: -${({ theme }) => theme.grid.containerGap};

  .swiper-slide {
    text-align: center;
  }

  @media all and (min-width: ${({ breakpoint }) => breakpoint}px) {
    margin-left: 0;
    margin-right: 0;
  }
  .swiper-button-prev {
    left: 0rem;
  }
  .swiper-button-next {
    right: 0rem;
  }
  [class^="swiper-button-"] {
    color: white;
    background-color: rgba(0, 0, 0, 0.6);
    padding: .5rem;
    visibility: hidden;
    @media all and (min-width: ${({ breakpoint }) => breakpoint}px) {
      visibility: visible;
    }
    &:after {
      font-size: 1rem;
      @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
        font-size: 1.5rem;
      }
    }
    &.swiper-button-disabled {
      display: none;
    }
  }
`;

const Overlay = styled(Image)`
  position: absolute !important;
  top: 0;
  left: 0;
`;

const OnClickButton = styled(Button).attrs({ wrapper: true })`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0;
  cursor: pointer;
`;

export default Slideshow;
